import { Mail } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { Box } from "@mui/system";
import { PrimaryButton } from "app/components/Button/PrimaryButton";
import { TextField } from "app/components/TextField";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import confusion from "../LoginPage/assets/forgot.png";
import Redirect from "../components/Redirect";
import { emailValidator } from "utils/helpers";
import { selectForgotEmail, selectForgotError, selectLoading } from "../selectors";
import { actions } from "../slice";
import { useStyles } from "./styles";
type Props = {};
const ForgotPassword = (props: Props) => {
  const styles = useStyles();
  const [isSubmitted, setSubmitted] = useState<boolean>(false);
  const email = useSelector(selectForgotEmail);
  const error = useSelector(selectForgotError);
  const isLoading = useSelector(selectLoading);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    dispatch(actions.resetEmail());
    dispatch(actions.resetError());
    setSubmitted(false);
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      dispatch(actions.dispatchForgotError("AUTH.VALIDATION.EMAIL_REQUIRED"));
      return;
    }
    if (!emailValidator(email)) {
      dispatch(actions.dispatchForgotError("AUTH.VALIDATION.EMAIL_INVALID"));
      return;
    }

    dispatch(
      actions.forgotPassword({
        callback: () => setSubmitted(true),
      }),
    );
  };
  const handleEmailChange = (e) => {
    const { value } = e.target;
    if (error) {
      dispatch(actions.resetError());
    }
    dispatch(actions.setForgotEmail(value));
  };
  const forgotSubmitContent = (
    <>
      <Box className={styles.form}>
        <Box className={styles.successHeading}>{t("AUTH.RESET_PASSWORD")}</Box>
        <Mail className={styles.iconMail} />
        <Box className={styles.mailSent}>
          {t("AUTH.RESET_PASSWORD_MESSAGE")}
        </Box>
        <div className={styles.descText}>{t("AUTH.RESET_PASSWORD_DESC")}</div>
      </Box>
    </>
  );
  const errorMsg = error ? t(error) : "";
  const forgotForm = (
    <Redirect>
      <form className={styles.form} noValidate onSubmit={handleSubmit}>
        {errorMsg && (
          <Alert className={styles.error} severity="error">
            {errorMsg}
          </Alert>
        )}
        <Box mb={2} className={styles.heading}>
          {t("AUTH.FORGOT_PASSWORD")} ?
        </Box>
        <img src={confusion} alt="forgot_person" />
        <Box className={styles.subHeading} mt={2}>
          {t("AUTH.FORGOT_PASSWORD_HEADING")}
        </Box>
        <Box className={styles.resetMsgText} mb={1}>
          {t("AUTH.FORGOT_PASSWORD_SUB_HEADING")}
        </Box>
        <div dir="ltr" className={styles.emailWrapper}>
          <TextField
            height={51}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            type="email"
            placeholder={t("AUTH.RESET_PASSWORD_PLACEHOLDER")}
            name="Email"
            autoComplete="email"
            autoFocus
            error={!!errorMsg}
            helperText={errorMsg}
            FormHelperTextProps={{
              className:
                i18n.dir() === "ltr"
                  ? styles.helperTextLtr
                  : styles.helperTextRtl,
            }}
            value={email}
            onChange={handleEmailChange}
          />
        </div>

        <PrimaryButton isLoading={isLoading} label={t("BUTTONS.SEND")} />
      </form>
    </Redirect>
  );
  return !isSubmitted ? forgotForm : forgotSubmitContent;
};
export default ForgotPassword;
